





























































































































// Components
import { VHover, VListItem } from 'vuetify/lib'
import { logout } from '@/shared/api'
import { defineComponent, ref, computed } from '@vue/composition-api'
import { Textbook, TextbookIssue } from '@/shared/types'
import { mapState, mapMutations } from 'vuex'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { useStore as useUserStore } from '@/shared/state-management/userStore'
export default defineComponent({
  name: 'DashboardCoreAppBar',

  components: {
    AppBarItem: {
      render(h: Function) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }: { hover: unknown }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    'black--text': !hover,
                    'white--text secondary elevation-12': hover,
                  },
                  props: {
                    activeClass: '',
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              )
            },
          },
        })
      },
    },
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { root }) {
    const notifications = ref([])
    const { user } = useUserStore().getters

    const { textbooks } = useTextbookStore().getters
    const name = computed(() =>
      user.value ? user.value.firstname + ' ' + user.value.lastname : ''
    )

    const translationParameters = computed(() => {
      const textbookId = root.$route.params.textbookId
      const textbookIssueId = root.$route.params.textbookIssueId

      if (textbookIssueId) {
        const textbookIssue = textbooks.value
          .reduce(
            (issues: Array<TextbookIssue>, textbook: Textbook) => [
              ...issues,
              ...textbook.issues,
            ],
            [] as Array<TextbookIssue>
          )
          .filter((issue: TextbookIssue) => issue.id === textbookIssueId)
          .pop()
        return {
          textbookIssueName: textbookIssue ? textbookIssue.name : '',
          textbookName: textbookIssue ? textbookIssue.textbookName : '',
        }
      }

      if (textbookId) {
        const textbook = textbooks.value
          .filter((textbook: Textbook) => textbook.id === textbookId)
          .pop()
        return { textbookName: textbook ? textbook.name : '' }
      }

      return {}
    })

    const profile = computed(() =>
      !name.value
        ? []
        : [
            { title: name.value, avatar: true, route: { name: 'UserProfile' } },
            { divider: true },
            { title: 'Abmelden', logout: true },
          ]
    )

    const logoutHandler = async (): Promise<void> => {
      await logout()
      root.$router.push({ name: 'Login' })
    }

    return {
      notifications,
      profile,
      logoutHandler,
      name,
      translationParameters,
    }
  },
  computed: {
    ...mapState(['drawer']),
  },
  methods: {
    ...mapMutations({ setDrawer: 'SET_DRAWER' }),
  },
})
